import i18n from '@/i18n/i18n'

export const getErrorMessage = (codes, errorItems) => {
  let errorCodes

  // Проверяем, является ли codes массивом
  if (Array.isArray(codes)) {
    errorCodes = codes
  } else {
    // Если не массив — оборачиваем в массив, чтобы обработать как один элемент
    errorCodes = [codes]
  }

  // Собираем сообщения
  const errorMessages = errorCodes.map((code) => {
    const key = errorItems[code]
    // Если ключ найден — локализуем, иначе используем code
    return key ? i18n.t(key) : code
  })

  // Объединяем через новую строку
  return errorMessages.join('\n')
}

export const FILES_ERROR_MESSAGE_MAP = {
  BANNER_SIZE_ERROR: 'toast.fileError',
  ANIMATION_BANNER_DURATION_ERROR: 'toast.fileAnimationError',
  AUDIO_FILE_PARSE_ERROR: 'toast.fileAudioError',
  VIDEO_FILE_PARSE_ERROR: 'toast.fileVideoError',
  JS_BANNER_FILE_PARSE_ERROR: 'toast.fileJsError',
  HTML5_BANNER_AD_SIZE_TAG_ERROR: 'toast.fileHtmlSizeError',
  HTML5_BANNER_DURATION_TAG_ERROR: 'toast.fileHtmlDurationError',
  HTML5_BANNER_FILL_CLICK_TAG_ERROR: 'toast.fileHtmlClickError',
  HTML5_BANNER_CLICK_TAG_NOT_FOUND_ERROR: 'toast.fileHtmlClickTagError',
  HTML5_BANNER_CLICK_TAG_NOT_USE_ERROR: 'toast.fileHtmlClickTagNotUseError',
  FILE_SIZE_ERROR: 'toast.fileSizeError',
  FILE_NOT_FOUND: 'toast.fileNotFound',
  ERR_BAD_RESPONSE: 'toast.errBadResponse',
}

export const ERROR_MESSAGE_MAP = {
  ECONNABORTED: 'toast.timeout',
  DATABASE_QUERY_TIMEOUT: 'toast.timeout',
  BAD_CREDENTIALS: 'toast.authCredentials',
  EMAIL_IN_USE: 'toast.emailUse',
  PHONE_IN_USE: 'toast.phoneUse',
  CONTRACT_NUMBER_IN_USE: 'toast.contractNumberUse',
  CREATE_TARGET_ERROR: 'toast.createTargetError',
  NO_MODERATED_CREATIVES: 'toast.noModeratedCreatives',
  FILE_NOT_FOUND: 'toast.fileNotFound',
  USER_CONTRACT_NOT_FOUND: 'toast.userContractNotFound',
  EXCHANGE_RATE_SAME_CURRENCY: 'toast.exchangeRateSame',
  EXCHANGE_RATE_EXIST: 'toast.exchangeRateExist',
  CAMPAIGN_END_DATE_PAST_ERROR: 'toast.campaignEndDatePast',
  VAT_EXIST: 'toast.financeVatExist',
  LOGIN_IN_USE: 'toast.loginInUse',
  PUBLIC_ZONE_INFO_NOT_FOUND: 'toast.infoNotFound',
  NOT_POSSIBLE_UPDATE_VAST_DAAST_CREATIVE: 'toast.notPossibleUpdateCreative',
  PASSWORDS_DO_NOT_MATCH: 'toast.passwordsDoNotMatch',
  CURRENT_PASSWORD_IS_WRONG: 'toast.currentPasswordIsWrong',
  RESET_PASSWORD_TOKEN_EXPIRED_ERROR: 'toast.expiredPasswordToken',
  SUCCESS: 'toast.success',
  UNEXPECTED: 'toast.unexpected',
  RULE_IN_USE: 'toast.ruleInUse',
  IS_NOT_HUMAN: 'toast.isNotHuman',
  VK_ORD_ERROR: 'toast.vkOrdError',
  BANK_IS_BLANK: 'toast.bankIsBlank',
  TARGET_IN_USE: 'toast.targetInUse',
  STORAGE_ERROR: 'toast.storageError',
  USER_NOT_FOUND: 'toast.userNotFound',
  CREATIVE_IN_USE: 'toast.creativeInUse',
  FILE_READ_ERROR: 'toast.fileReadError',
  COUNTRY_IS_BLANK: 'toast.countryIsBlank',
  PDF_RENDER_ERROR: 'toast.pdfRenderError',
  YANDEX_ORD_ERROR: 'toast.yandexOrdError',
  BANNER_SIZE_ERROR: 'toast.bannerSizeError',
  CREATE_RULE_ERROR: 'toast.createRuleError',
  NOT_HAS_PERMISSION: 'toast.notHasPermission',
  RESET_PASSWORD_ERROR: 'toast.resetPasswordError',
  USER_STATISTIC_ERROR: 'toast.userStatisticError',
  PARSE_TEXT_FILE_ERROR: 'toast.parseTextFileError',
  CREATE_CREATIVE_ERROR: 'toast.createCreativeError',
  UPDATE_CREATIVE_ERROR: 'toast.updateCreativeError',
  UPDATE_CAMPAIGN_ERROR: 'toast.updateCampaignError',
  CREATE_CAMPAIGN_ERROR: 'toast.createCampaignError',
  BANK_ACCOUNT_IS_BLANK: 'toast.bankAccountIsBlank',
  AGREEMENT_TYPE_IS_NULL: 'toast.agreementTypeIsNull',
  USER_INVOICE_NOT_FOUND: 'toast.userInvoiceNotFound',
  AGREEMENT_NOT_ACCEPTED: 'toast.agreementNotAccepted',
  AGREEMENT_DATE_IS_NULL: 'toast.agreementDateIsNull',
  USER_ACT_FILE_IS_EXISTS: 'toast.userActFileIsExists',
  USER_ACT_FILE_NOT_EXISTS: 'toast.userActFileNotExists',
  AGREEMENT_EFFECT_IS_NULL: 'toast.agreementEffectIsNull',
  PASSWORD_ALREADY_CHANGED: 'toast.passwordAlreadyChanged',
  USER_VAST_DAAST_EXCEPTION: 'toast.userVastDaastException',
  AGREEMENT_SUBJECT_IS_NULL: 'toast.agreementSubjectIsNull',
  AGREEMENT_NUMBER_IS_BLANK: 'toast.agreementNumberIsBlank',
  ORGANIZATION_TYPE_IS_NULL: 'toast.organizationTypeIsNull',
  USER_INVOICE_IS_PAID_ERROR: 'toast.userInvoiceIsPaidError',
  UNKNOWN_USER_COUNTRY_ERROR: 'toast.unknownUserCountryError',
  BIN_OR_SWIFT_CODE_IS_BLANK: 'toast.binOrSwiftCodeIsBlank',
  REGISTRATION_CODE_IS_BLANK: 'toast.registrationCodeIsBlank',
  ORGANIZATION_NAME_IS_BLANK: 'toast.organizationNameIsBlank',
  USER_PAYMENT_INFO_NOT_FOUND: 'toast.userPaymentInfoNotFound',
  ADD_USER_PAYMENT_INFO_ERROR: 'toast.addUserPaymentInfoError',
  USER_INVOICE_FILE_IS_EXISTS: 'toast.userInvoiceFileIsExists',
  VK_ORD_REGISTER_PERSON_ERROR: 'toast.vkOrdRegisterPersonError',
  USER_CONTRACT_FILE_IS_EXISTS: 'toast.userContractFileIsExists',
  USER_INVOICE_FILE_NOT_EXISTS: 'toast.userInvoiceFileNotExists',
  ORGANIZATION_ADDRESS_IS_BLANK: 'toast.organizationAddressIsBlank',
  USER_CONTRACT_IS_SIGNED_ERROR: 'toast.userContractIsSignedError',
  VK_ORD_REGISTER_CONTRACT_ERROR: 'toast.vkOrdRegisterContractError',
  CAMPAIGN_EXCHANGES_EMPTY_ERROR: 'toast.campaignExchangesEmptyError',
  MAX_COUNT_GROUP_PARAMS_EXCEEDED: 'toast.maxCountGroupParamsExceeded',
  MEDIATOR_AGREEMENT_TYPE_IS_NULL: 'toast.mediatorAgreementTypeIsNull',
  MEDIATOR_AGREEMENT_DATE_IS_NULL: 'toast.mediatorAgreementDateIsNull',
  NOT_SUPPORT_FILE_EXTENSION_ERROR: 'toast.notSupportFileExtensionError',
  USER_BALANCE_REPLENISHMENT_ERROR: 'toast.userBalanceReplenishmentError',
  STATE_REGISTRATION_CODE_IS_BLANK: 'toast.stateRegistrationCodeIsBlank',
  VK_ORD_REGISTER_MEDIA_FILE_ERROR: 'toast.vkOrdRegisterMediaFileError',
  HTML5_BANNER_ZIP_FILE_PARSE_ERROR: 'toast.html5BannerZipFileParseError',
  MEDIATOR_AGREEMENT_EFFECT_IS_NULL: 'toast.mediatorAgreementEffectIsNull',
  MEDIATOR_AGREEMENT_NUMBER_IS_NULL: 'toast.mediatorAgreementNumberIsNull',
  USER_ACT_WORK_PERFORMED_NOT_FOUND: 'toast.userActWorkPerformedNotFound',
  MEDIATOR_AGREEMENT_SUBJECT_IS_NULL: 'toast.mediatorAgreementSubjectIsNull',
  MEDIATOR_ORGANIZATION_TYPE_IS_NULL: 'toast.mediatorOrganizationTypeIsNull',
  MEDIATOR_ORGANIZATION_NAME_IS_NULL: 'toast.mediatorOrganizationNameIsNull',
  MEDIATOR_REGISTRATION_CODE_IS_NULL: 'toast.mediatorRegistrationCodeIsNull',
  CURRENT_USER_WRITE_OFF_BALANCE_ERROR: 'toast.currentUserWriteOffBalanceError',
  CURRENT_USER_ACT_WORK_PERFORMED_ERROR: 'toast.currentUserActWorkPerformedError',
  USER_CONTRACT_FILE_NOT_UPLOADED_ERROR: 'toast.userContractFileNotUploadedError',
  ECONOMIC_ACTIVITY_TYPE_NUMBER_IS_BLANK: 'toast.economicActivityTypeNumberIsBlank',
  YANDEX_ORD_REGISTER_ORGANISATION_ERROR: 'toast.yandexOrdRegisterOrganisationError',
  ADD_DAAST_VAST_MARKUP_PERMISSION_DENIED: 'toast.addDaastVastMarkupPermissionDenied',
  CAMPAIGN_DAILY_BUDGET_LIMIT_ERROR: 'toast.campaignDailyBudgetLimitError',
  UPDATE_INN_OR_MEDIATOR_OR_MEDIATOR_INN_NOT_HAS_PERMISSION: 'toast.updateInnNotHasPermission',
  VAT_VALUE_IS_EMPTY: 'toast.vatValueIsEmpty',
  VAT_COUNTRY_NAME_IS_EMPTY: 'toast.vatCountryNameIsEmpty',
  VAT_COUNTRY_IS_EMPTY: 'toast.vatCountryIsEmpty',
  PAGE_IS_EMPTY: 'toast.pageIsEmpty',
  SIZE_IS_EMPTY: 'toast.sizeIsEmpty',
  SORT_IS_EMPTY: 'toast.sortIsEmpty',
  USER_ROLE_IS_EMPTY: 'toast.userRoleIsEmpty',
  WRONG_EMAIL_FORMAT: 'toast.wrongEmailFormat',
  USER_PERMISSIONS_IS_EMPTY: 'toast.userPermissionsIsEmpty',
  CLIENT_BID_MARGIN_IS_EMPTY: 'toast.clientBidMarginIsEmpty',
  CLIENT_TIME_ZONE_IS_EMPTY: 'toast.clientTimeZoneIsEmpty',
  CLIENT_CURRENCY_IS_EMPTY: 'toast.clientCurrencyIsEmpty',
  CLIENT_AGREEMENT_IS_EMPTY: 'toast.clientAgreementIsEmpty',
  WRONG_NEW_PASSWORD_FORMAT: 'toast.wrongNewPasswordFormat',
  WRONG_CURRENT_PASSWORD_FORMAT: 'toast.wrongCurrentPasswordFormat',
  WRONG_CONFIRM_PASSWORD_FORMAT: 'toast.wrongConfirmPasswordFormat',
  LOGIN_IS_EMPTY: 'toast.loginIsEmpty',
  AGREEMENT_IS_EMPTY: 'toast.agreementIsEmpty',
  CURRENCY_IS_EMPTY: 'toast.currencyIsEmpty',
  TIME_ZONE_IS_EMPTY: 'toast.timeZoneIsEmpty',
  WRONG_PASSWORD_FORMAT: 'toast.wrongPasswordFormat',
  USER_LOGIN_IS_EMPTY: 'toast.userLoginIsEmpty',
  USER_CURRENCY_IS_EMPTY: 'toast.userCurrencyIsEmpty',
  USER_TIME_ZONE_IS_EMPTY: 'toast.userTimeZoneIsEmpty',
  TARGET_NAME_IS_EMPTY: 'toast.targetNameIsEmpty',
  TARGET_STATUS_NOT_SELECT: 'toast.targetStatusNotSelect',
  TARGET_GEO_LIST_IS_EMPTY: 'toast.targetGeoListIsEmpty',
  DATE_TO_IS_EMPTY: 'toast.dateToIsEmpty',
  DATE_FROM_IS_EMPTY: 'toast.dateFromIsEmpty',
  RULE_NAME_IS_EMPTY: 'toast.ruleNameIsEmpty',
  RULE_STATUS_IS_EMPTY: 'toast.ruleStatusIsEmpty',
  RULE_TYPE_IS_EMPTY: 'toast.ruleTypeIsEmpty',
  RULE_TIME_RANGE_IS_EMPTY: 'toast.ruleTimeRangeIsEmpty',
  INTEGRATION_NAME_IS_EMPTY: 'toast.integrationNameIsEmpty',
  INTEGRATION_STATUS_IS_EMPTY: 'toast.integrationStatusIsEmpty',
  INTEGRATION_CURRENCY_IS_EMPTY: 'toast.integrationCurrencyIsEmpty',
  INTEGRATION_CATEGORY_IS_EMPTY: 'toast.integrationCategoryIsEmpty',
  INTEGRATION_RTB_VERSION_IS_EMPTY: 'toast.integrationRtbVersionIsEmpty',
  INTEGRATION_SSP_SPECIFIC_PROCESSING_KEY_IS_EMPTY: 'toast.integrationSspSpecificProcessingKeyIsEmpty',
  INTEGRATION_CREATIVE_TYPES_IS_EMPTY: 'toast.integrationCreativeTypesIsEmpty',
  UPI_COUNTRY_IS_EMPTY: 'toast.upiCountryIsEmpty',
  UPI_AGREEMENT_NUMBER_IS_EMPTY: 'toast.upiAgreementNumberIsEmpty',
  UPI_REGISTRATION_CODE_IS_EMPTY: 'toast.upiRegistrationCodeIsEmpty',
  UPI_ORGANIZATION_NAME_IS_EMPTY: 'toast.upiOrganizationNameIsEmpty',
  UPI_AGREEMENT_DATE_IS_EMPTY: 'toast.upiAgreementDateIsEmpty',
  SEARCH_ORGANIZATION_COUNTRY_IS_EMPTY: 'toast.searchOrganizationCountryIsEmpty',
  SEARCH_ORGANIZATION_STAT_REGISTRATION_CODE_IS_EMPTY: 'toast.searchOrganizationStatRegistrationCodeIsEmpty',
  REPLENISH_USER_BALANCE_USER_ID_IS_EMPTY: 'toast.replenishUserBalanceUserIdIsEmpty',
  REPLENISH_USER_BALANCE_INVOICE_ID_IS_EMPTY: 'toast.replenishUserBalanceInvoiceIdIsEmpty',
  REPLENISH_USER_BALANCE_AMOUNT_IS_EMPTY: 'toast.replenishUserBalanceAmountIsEmpty',
  REPLENISH_USER_BALANCE_PDOC_NUMBER_IS_EMPTY: 'toast.replenishUserBalancePdocNumberIsEmpty',
  ACT_USER_ID_IS_EMPTY: 'toast.actUserIdIsEmpty',
  ACT_ID_IS_EMPTY: 'toast.actIdIsEmpty',
  ACT_ORD_ACTION_IS_EMPTY: 'toast.actOrdActionIsEmpty',
  ACT_SERIAL_IS_EMPTY: 'toast.actSerialIsEmpty',
  ACT_FILENAME_IS_EMPTY: 'toast.actFilenameIsEmpty',
  ACT_AMOUNT_IS_EMPTY: 'toast.actAmountIsEmpty',
  EXCHANGE_RATE_VALUE_IS_EMPTY: 'toast.exchangeRateValueIsEmpty',
  EXCHANGE_RATE_CURRENCY_TO_IS_EMPTY: 'toast.exchangeRateCurrencyToIsEmpty',
  EXCHANGE_RATE_CURRENCY_FROM_IS_EMPTY: 'toast.exchangeRateCurrencyFromIsEmpty',
  GEO_SECTION_IS_EMPTY: 'toast.geoSectionIsEmpty',
  GEO_COUNTRY_CODE_IS_EMPTY: 'toast.geoCountryCodeIsEmpty',
  GEO_REGION_IS_EMPTY: 'toast.geoRegionIsEmpty',
  GEO_LANG_IS_EMPTY: 'toast.geoLangIsEmpty',
  GEO_REGION_CODE_IS_EMPTY: 'toast.geoRegionCodeIsEmpty',
  CREATIVE_IAB_CATEGORY_IS_EMPTY: 'toast.creativeIabCategoryIsEmpty',
  CREATIVE_KKTU_CODES_IS_EMPTY: 'toast.creativeKktuCodesIsEmpty',
  CREATIVE_MODERATION_STATUS_IS_EMPTY: 'toast.creativeModerationStatusIsEmpty',
  CREATIVE_NAME_IS_EMPTY: 'toast.creativeNameIsEmpty',
  CREATIVE_SUBTYPE_IS_EMPTY: 'toast.creativeSubtypeIsEmpty',
  CREATIVE_TYPE_IS_EMPTY: 'toast.creativeTypeIsEmpty',
  CREATIVE_CAMPAIGN_STRATEGY_IS_EMPTY: 'toast.creativeCampaignStrategyIsEmpty',
  CREATIVE_VIDEO_FINAL_URL_IS_EMPTY: 'toast.creativeVideoFinalUrlIsEmpty',
  CREATIVE_VIDEO_DISPLAY_URL_IS_EMPTY: 'toast.creativeVideoDisplayUrlIsEmpty',
  CREATIVE_NATIVE_DESC_IS_EMPTY: 'toast.creativeNativeDescIsEmpty',
  CREATIVE_NATIVE_CTA_TEXT_IS_EMPTY: 'toast.creativeNativeCtaTextIsEmpty',
  CREATIVE_NATIVE_FINAL_URL_IS_EMPTY: 'toast.creativeNativeFinalUrlIsEmpty',
  CREATIVE_NATIVE_SPONSORED_IS_EMPTY: 'toast.creativeNativeSponsoredIsEmpty',
  CREATIVE_NATIVE_DISPLAY_URL_IS_EMPTY: 'toast.creativeNativeDisplayUrlIsEmpty',
  CREATIVE_NATIVE_SMALL_TITLE_IS_EMPTY: 'toast.creativeNativeSmallTitleIsEmpty',
  CREATIVE_NATIVE_IMAGES_IS_EMPTY: 'toast.creativeNativeImagesIsEmpty',
  CREATIVE_BANNER_W_IS_EMPTY: 'toast.creativeBannerWIsEmpty',
  CREATIVE_BANNER_H_IS_EMPTY: 'toast.creativeBannerHIsEmpty',
  CREATIVE_BANNER_MIME_TYPE_IS_EMPTY: 'toast.creativeBannerMimeTypeIsEmpty',
  CREATIVE_BANNER_FILENAME_IS_EMPTY: 'toast.creativeBannerFilenameIsEmpty',
  CREATIVE_BANNER_FINAL_URL_IS_EMPTY: 'toast.creativeBannerFinalUrlIsEmpty',
  CREATIVE_BANNER_DISPLAY_URL_IS_EMPTY: 'toast.creativeBannerDisplayUrlIsEmpty',
  CREATIVE_AUDIO_FINAL_URL_IS_EMPTY: 'toast.creativeAudioFinalUrlIsEmpty',
  CREATIVE_AUDIO_DISPLAY_URL_IS_EMPTY: 'toast.creativeAudioDisplayUrlIsEmpty',
  CAMPAIGN_STATUS_IS_EMPTY: 'toast.campaignStatusIsEmpty',
  CAMPAIGN_NAME_IS_EMPTY: 'toast.campaignNameIsEmpty',
  CAMPAIGN_TOTAL_BUDGET_IS_EMPTY: 'toast.campaignTotalBudgetIsEmpty',
  CAMPAIGN_DAILY_BUDGET_IS_EMPTY: 'toast.campaignDailyBudgetIsEmpty',
  CAMPAIGN_IS_USER_IMPRESSION_FREQ_SET_IS_EMPTY: 'toast.campaignIsUserImpressionFreqSetIsEmpty',
  CAMPAIGN_STRATEGY_IS_EMPTY: 'toast.campaignStrategyIsEmpty',
  CAMPAIGN_BIDDER_STATUS_IS_EMPTY: 'toast.campaignBidderStatusIsEmpty',
  CAMPAIGN_BID_TYPE_IS_EMPTY: 'toast.campaignBidTypeIsEmpty',
  CAMPAIGN_CREATIVE_GROUPS_IS_EMPTY: 'toast.campaignCreativeGroupsIsEmpty',
  CAMPAIGN_TYPE_IS_EMPTY: 'toast.campaignTypeIsEmpty',
  RESET_PASSWORD_TOKEN_IS_EMPTY: 'toast.resetPasswordTokenIsEmpty',
  REFRESH_TOKEN_IS_EMPTY: 'toast.refreshTokenIsEmpty',
  VAT_NOT_FOUND: 'toast.vatNotFound',
  DUPLICATE_TARGET_ERROR: 'toast.duplicateTargetError',
  ISSUE_DATE_IS_EMPTY: 'toast.issueDateIsEmpty',
  CAMPAIGN_DAILY_BUDGET_IS_LESS_ZERO: 'toast.campaignDailyBudgetIsLessZero',
  CREATIVE_GROUP_MAX_PRICE_IS_LESS_ZERO: 'toast.creativeGroupMaxPriceIsLessZero',
  CREATIVE_GROUP_MAX_PRICE_IS_EMPTY: 'toast.creativeGroupMaxPriceIsEmpty',
  ERR_BAD_RESPONSE: 'toast.errBadResponse',
  CLIENT_DISCONNECT: 'toast.clientDisconnect',
  IS_NEED_REGISTERED_ON_ORD: 'toast.isNeedRegisteredOnOrd',
  CAMPAIGN_TOTAL_BUDGET_IS_LESS_ZERO: 'toast.campaignTotalBudgetIsLessZero',
  AUDIENCE_LIFETIME_MAX_VALUE_ERROR: 'toast.audienceLifetimeMaxValueError',
  CAMPAIGN_DEAL_IS_EXISTS: 'toast.campaignDealIsExists',
  USER_PAYMENT_INFO_ORD_REGISTER_FILLED: 'toast.userPaymentInfoOrdRegisterFilled',
  MANUAL_ACT_UPDATE_ORD_DATE_ERROR: 'toast.manualActUpdateOrdDateError',
}
